export type NauErrorPayload = {
  code?: number;
  message?: string;
  error?: string;
};

export const TURNSTILE_REQUIRED_MESSAGE =
  "Vui lòng hoàn thành xác minh bảo mật để tiếp tục đăng ký.";

const ERROR_CODE_MESSAGES: Record<number, string> = {
  1112: "Số điện thoại đã tồn tại",
  1113: "Số điện thoại trống",
  1114: "Số điện thoại không hợp lệ",
  1121: "Email đã tồn tại",
  1122: "Email trống",
  1123: "Email không hợp lệ",
  30101: "Username không hợp lệ",
  30103: "Username quá ngắn",
  30104: "Username quá dài",
  30105: "Username có ký tự không hợp lệ",
  30106: "Prefix username không hợp lệ",
  30107: "Username đã tồn tại",
  30108: "Mật khẩu không hợp lệ",
  30110: "Mật khẩu quá ngắn",
  30112: "Mật khẩu có khoảng trắng",
  30201: "Username trống",
  30202: "Password trống",
  30203: "Username hoặc Password không hợp lệ",
  40000: "Nhà cung cấp không được tìm thấy",
  30111: "Mật khẩu không được chứa ký tự tiếng Việt có dấu",
};

const DEFAULT_ERROR_MESSAGE = "Đăng ký thất bại, vui lòng thử lại sau.";

export const isTurnstileRequiredError = (
  status: number,
  payload: NauErrorPayload | null
): boolean => status === 409 && payload?.error === "turnstile_required";

export const getSignupErrorMessage = (
  status: number,
  payload: NauErrorPayload | null
) => {
  if (isTurnstileRequiredError(status, payload)) {
    return TURNSTILE_REQUIRED_MESSAGE;
  }

  if (status === 409) {
    return "Bạn đã vượt quá số lần đăng ký, vui lòng thử lại sau.";
  }

  if (status === 503) {
    return "Có lỗi xảy ra trong lúc đăng ký.";
  }

  const code = payload?.code;
  if (code && ERROR_CODE_MESSAGES[code]) {
    return ERROR_CODE_MESSAGES[code];
  }

  if (payload?.message) {
    return payload.message;
  }

  return DEFAULT_ERROR_MESSAGE;
};

export const getSigninErrorMessage = (
  status: number,
  payload: NauErrorPayload | null
) => {
  if (status === 503) {
    return "Có lỗi xảy ra trong lúc đăng ký.";
  }

  if (status === 409) {
    return "Đăng nhập tạm thời không khả dụng, vui lòng thử lại.";
  }

  const code = payload?.code;
  if (code && ERROR_CODE_MESSAGES[code]) {
    return ERROR_CODE_MESSAGES[code];
  }

  if (payload?.message) {
    return payload.message;
  }

  return "Đăng nhập thất bại, vui lòng thử lại.";
};
